module.exports = __webpack_public_path__ + "img/xml.a03b766e.png";